import React from 'react';
import CustomSelectEx from '@/ctComponents/CustomSelectEx';

const priorityOptions = [
  { label: 'None', value: 'NONE' },
  { label: 'High', value: 'HIGH' },
  { label: 'Medium', value: 'MEDIUM' },
  { label: 'Low', value: 'LOW' },
  { label: 'Exclude', value: 'EXCLUDE' },
];

const MinimalPrioritySelect = ({ value, onChange }) => (
  <CustomSelectEx
    options={priorityOptions}
    value={priorityOptions.find((opt) => opt.value === value) || ''}
    onChange={(opt) => onChange(opt?.value || '')}
    placeholder="Select Priority"
    width={'100%'}
    minWidth={'135px'}
    dropdown={true}
  />
);

const TerminalPreferences = ({ terminalPrefs, setTerminalPrefs }) => {
  return (
    <div className="terminal-section">
      <div className="terminal-grid">
        {Object.keys(terminalPrefs)?.map((terminal) => (
          <div key={terminal} className="terminal-box">
            <span className="terminal-label">{terminal}</span>
            <MinimalPrioritySelect
              value={terminalPrefs[terminal].priority}
              onChange={(val) =>
                setTerminalPrefs((prev) => ({
                  ...prev,
                  [terminal]: {
                    ...prev[terminal],
                    priority: val,
                  },
                }))
              }
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TerminalPreferences;
